import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './styles/index.css';

import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { registerUnauthorizedHandler, useAuthStore } from './app/authStore';
import { ToastProvider } from './components/feedback';

/**
 * 应用入口。
 *
 * 挂载前先做两件事：注册全局 401 兜底，然后拉一次会话。
 * 拉会话期间界面停在「loading」而不是先渲染登录页再跳走 ——
 * 否则每次刷新已登录的页面都会闪一下登录表单。
 */
function Root() {
  const bootstrap = useAuthStore((state) => state.bootstrap);

  useEffect(() => {
    const unregister = registerUnauthorizedHandler();
    void bootstrap();
    return unregister;
  }, [bootstrap]);

  return <App />;
}

const container = document.getElementById('root');
if (!container) throw new Error('找不到 #root 挂载点');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <Root />
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);
